const MinusPlus02Icon = /*#__PURE__*/ [
  ["path", { d: "M3 21L21 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 13V21M21 17L13 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 7L3 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { MinusPlus02Icon as default };
//# sourceMappingURL=MinusPlus02Icon.js.map
